import { FC, useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import { ChatbotDistributionSettingFields_root$key } from "~/src/__relay_artifacts__/ChatbotDistributionSettingFields_root.graphql";
import {
  DeliverUrlListField,
  ReferrerListField,
  SelectResourceListField,
  TargetCookieListField,
  VisitCountField,
} from "~/src/components/features/global/DistributionSetingForm";

type Props = {
  rootRef: ChatbotDistributionSettingFields_root$key;
};

const fragment = graphql`
  fragment ChatbotDistributionSettingFields_root on Query {
    sources {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const ChatbotDistributionSettingFields: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ rootRef }) => {
  const { sources } = useFragment(fragment, rootRef);

  const sourceOptions = useMemo(
    () =>
      sources.edges?.map((edge) => {
        const node = edge?.node;
        if (!node) throw new Error("assertion failed");
        return { label: node.name, value: node.id };
      }) || [],
    [sources.edges]
  );

  return (
    <>
      <SelectResourceListField
        name="sourceIds"
        label="表示条件に流入元カテゴリを追加する"
        options={sourceOptions}
      />
      <ReferrerListField name="referrers" label="表示条件に流入元を追加する" />
      <ReferrerListField
        name="excludeReferrers"
        label="表示条件に除外流入元を追加する"
      />
      <VisitCountField label="表示条件にユーザーの訪問回数を追加" />
      <DeliverUrlListField
        name="deliverTargetUrls"
        label="表示条件に該当ページを閲覧したユーザーを追加"
      />
      <DeliverUrlListField
        name="deliverExcludeUrls"
        label="非表示条件に該当ページを閲覧したユーザーを追加"
      />
      <TargetCookieListField name="targetCookies" label="Cookieの条件を追加" />
    </>
  );
};
